import { getRootContainerProps, getRootContainerPropsDep } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import Popup, { type PopupProps } from "@client/controls/Popup/container";
import React from "react";
import Disclaimer from "./Disclaimer/container";
import Heading from "./Heading/container";

const ContentPopup = (props: PopupProps & RootContainerProps) => {
  const heading = React.useMemo(
    () => <Heading {...getRootContainerProps(props)} />,
    [...getRootContainerPropsDep(props)]
  );

  const footer = React.useMemo(
    () => <Disclaimer {...getRootContainerProps(props)} />,
    [...getRootContainerPropsDep(props)]
  );

  return <Popup {...props} heading={heading} footer={footer} />;
};

export default ContentPopup;
